var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_2809_15795)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2809_15795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0857 17.2051C17.8241 17.2051 15.1714 19.8513 15.1714 23.1026C15.1714 26.3538 17.8241 29 21.0857 29C24.3473 29 27 26.3538 27 23.1026C27 19.8513 24.3473 17.2051 21.0857 17.2051ZM23.0966 23.8718H21.0857C20.6599 23.8718 20.3143 23.5272 20.3143 23.1026V21.0154C20.3143 20.5908 20.6599 20.2462 21.0857 20.2462C21.5115 20.2462 21.8571 20.5908 21.8571 21.0154V22.3333H23.0966C23.5224 22.3333 23.868 22.6779 23.868 23.1026C23.868 23.5272 23.5224 23.8718 23.0966 23.8718ZM22.1143 9H11.8286C10.2651 9 9 10.2615 9 11.8205V25.1538C9 26.7128 10.2651 27.9744 11.8286 27.9744H15.4697C14.3177 26.6718 13.6286 24.9692 13.6286 23.1026C13.6286 19 16.9714 15.6667 21.0857 15.6667C22.5051 15.6667 23.8217 16.0564 24.9429 16.7538V11.8205C24.9429 10.2615 23.6777 9 22.1143 9ZM13.8857 19.7692H12.8571C12.4354 19.7692 12.0857 19.4205 12.0857 19C12.0857 18.5795 12.4354 18.2308 12.8571 18.2308H13.8857C14.3074 18.2308 14.6571 18.5795 14.6571 19C14.6571 19.4205 14.3074 19.7692 13.8857 19.7692ZM16.9714 16.6923H12.8571C12.4354 16.6923 12.0857 16.3436 12.0857 15.9231C12.0857 15.5026 12.4354 15.1538 12.8571 15.1538H16.9714C17.3931 15.1538 17.7429 15.5026 17.7429 15.9231C17.7429 16.3436 17.3931 16.6923 16.9714 16.6923ZM21.0857 13.6154H12.8571C12.4354 13.6154 12.0857 13.2667 12.0857 12.8462C12.0857 12.4256 12.4354 12.0769 12.8571 12.0769H21.0857C21.5074 12.0769 21.8571 12.4256 21.8571 12.8462C21.8571 13.2667 21.5074 13.6154 21.0857 13.6154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2809_15795",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2809_15795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHistory);
export default __webpack_public_path__ + "static/media/share-History.0fb2f366240f26d71807e99bf9a2ba3d.svg";
export { ForwardRef as ReactComponent };